import React from 'react'
import {
  List,
  Avatar,
  Divider,
  Button,
  Modal,
  Input,
  Upload,
  Icon,
  message,
  Popconfirm
} from 'antd'
import moment from 'moment'

import './styles.scss'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
class HybrikProfiles extends React.Component {

  state = {
    modal: {},
    profiles: {}
  }

  componentDidMount() {
    this.setState({
      profiles: {
        loading: true
      }
    })
    CloudFlyerAPI
      .hybrik
      .fetchProfiles()
      .then(({ data }) => {
        this.setState({
          profiles: {
            data,
            loading: false
          }
        })
      })
  }

  toggleModal = () => {
    this.setState({
      modal: {
        visible: !this.state.modal.visible
      }
    })
  }

  handleNameChange = ({ target }) => {
    this.setState({
      modal: {
        ...this.state.modal,
        name: target.value
      }
    })
  }

  handleFileRemove = () => {
    this.setState({
      modal: {
        ...this.state.modal,
        file: null
      }
    })
  }

  handleFileBeforeUpload = (file) => {
    const isLt1M = file.size / 1024 / 1024 < 1
    const isJson = file.type === 'application/json'
    if (!isLt1M) {
      message.warn('File must be smaller that 1MB.')
    } if (!isJson) {
      message.warn('You can only upload JSON file.')
    } else {
      this.setState({
        modal: {
          ...this.state.modal,
          file,
          // prefill name filed with the filename if empty
          name: !this.state.modal.name
            ? file.name
            : this.state.modal.name
        }
      })
    }
    return false
  }

  createProfile = () => {
    const { modal, profiles } = this.state
    const { user } = this.props
    const formData = new FormData()
    // show loading 
    this.setState({
      modal: {
        ...modal,
        loading: true
      }
    })
    // build form data with file and source
    formData.append(
      'source',
      JSON.stringify(user.hybrik_profiles_bucket)
    )
    formData.append(
      'json_file',
      modal.file,
      modal.file.name
    )
    return CloudFlyerAPI
      .hybrik
      .createProfile(formData)
      .then(({ data: newProfile }) => {
        message.success('Profile file uploaded successfully.')
        // update UI
        const data = [...profiles.data, newProfile]
        this.setState({
          profiles: {
            data
          },
          modal: {
            visible: false,
            loading: false
          }
        })
      })
      .catch(() => {
        message.error(
          'An error occured while trying to upload your file, please try again.'
        )
      })
  }

  deleteProfile = (profileId) => {
    const { profiles } = this.state
    this.setState({
      // show loading
      profiles: {
        ...profiles,
        loading: true
      }
    })
    CloudFlyerAPI
      .hybrik
      .deleteProfile(profileId)
      .then(() => {
        // update UI
        const data = profiles.data.filter(p => p.id !== profileId)
        this.setState({
          profiles: {
            ...profiles,
            data,
            loading: false
          }
        })
      })
      .catch((err) => {
        console.log(err)
        message.error('An error occured while deleting this profile.')
      })
  }

  render() {
    const { profiles, modal } = this.state
    return (
      <div className='hybrik-profiles'>
        <Divider>Hybrik Profiles</Divider>
        <Button
          type='dashed'
          icon='plus'
          children='Add Profile'
          style={{ float: 'right' }}
          onClick={this.toggleModal}
        />
        <List
          itemLayout='horizontal'
          loading={profiles.loading}
          dataSource={profiles.data}
          style={{ clear: 'both' }}
          renderItem={item => {
            const createdAt = moment(item.created_at).format('MM/DD/YYYY')
            return (
              <List.Item actions={[
                <Popconfirm title='Are you sure you want to delete this profile?'
                  onConfirm={this.deleteProfile.bind(null, item.id)}
                  okText='Yes'
                  cancelText='No'>
                  <Button type='danger'
                    ghost>
                    Delete
                  </Button>
                </Popconfirm>
              ]}>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      icon='file-text'
                      style={{ background: '#1890ff' }}
                    />
                  }
                  title={
                    <a href='#'>{item.name}</a>
                  }
                  description={`Created at ${createdAt}`}
                />
                <div></div>
              </List.Item>
            )
          }}
        />
        <Modal
          title='Add profile'
          visible={modal.visible}
          confirmLoading={modal.loading}
          onOk={this.createProfile}
          onCancel={this.toggleModal}
          okText='Upload'
          className='add-profile'
        >
          <div>
            <label>File name</label>
            <Input
              placeholder='File name'
              value={modal.name}
              onChange={this.handleNameChange}
            />
          </div>
          <Divider />
          <div>
            <label>Upload JSON file</label>
            <Upload
              onRemove={this.handleFileRemove}
              beforeUpload={this.handleFileBeforeUpload}
              fileList={modal.file ? [modal.file] : []}
              accept='application/json'
              className='upload-profile'
            >
              <Button>
                <Icon type='upload' /> Select File
                </Button>
            </Upload>
          </div>
        </Modal>
      </div>
    )
  }
}

export default HybrikProfiles
